
<div class="component-content"> 
  <mat-icon class="footer-left-shape" svgIcon="footer-left-shape"></mat-icon> 
  <p>© Eurofins Scientific {{currentYear}}</p>
  <mat-icon class="logo" svgIcon="logo"></mat-icon>
  <mat-icon class="footer-right-shape" svgIcon="footer-right-shape"></mat-icon>
</div>
